// This can be our future entry point
import './initSentry';
import './babel/modules';
import './fonts/upicons.scss';
import 'App/pages/FullScreenPage/FullScreenPage.scss';
import './styles/legacy-dynamic-styles';
import './babel/angularConfig';
import './babel/angular/general';
import './babel/angular/resources';
import './babel/angular/filters';
import './babel/angular/security';
import './babel/angular/components';
import App from './App';
import { createRoot } from 'react-dom/client';
import './index.scss';
import installToolsShim from 'App/services/ToolsShim';
import installReactTemplatesShim from 'App/services/ReactTemplatesShim';
import { WithSplitProvider } from 'App/services/feature';

// Capture the Chrome side-panel marker (?upsalesExtension=1) at the earliest point —
// before any router runs — and persist it for the session so it survives the post-login
// navigation. Read by App/pages/EmbedAIChat/panelContext. WEB-7101.
try {
	if (new URLSearchParams(window.location.search).get('upsalesExtension') === '1') {
		window.sessionStorage.setItem('upsalesExtension', '1');
	}
} catch {
	// sessionStorage unavailable (privacy mode) — panel detection falls back to the query param.
}

const root = createRoot(document.getElementById('react-root'));
root.render(
	<WithSplitProvider>
		<App />
	</WithSplitProvider>
);

installToolsShim();
installReactTemplatesShim();

require('./babel/legacy-dynamic-load');
require('./babel/legacy-react');
require('./babel/angular/directives');
require('./babel/angular/common');
require('./babel/angular/domain');
